<template>
  <div>
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
      <WrCookieConfirmation />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
const url = useRequestURL();
const route = useRoute();

const WrCookieConfirmation = defineAsyncComponent(
  () => import("~/components/molecules/WrCookieConfirmation.vue")
);

import { computed, onMounted } from "vue";
import useLoadParticleCss from "~/composables/useLoadParticleCss";

onMounted(() => {
  // Load particle CSS once on the client
  useLoadParticleCss();
});

// Reactive computed values so head tags update on route changes
const baseUrl = computed(() => url.origin);
const currentPath = computed(() => route.path);
const canonicalUrl = computed(() => `${baseUrl.value}${currentPath.value}`);
const ogImageUrl = computed(() => `${baseUrl.value}/og-image.webp`);
const ogUrl = computed(() => canonicalUrl.value);

useHead({
  script: [
    {
      type: "text/javascript",
      defer: true,
      src: "//cdn.mouseflow.com/projects/98f74bbc-066e-4f88-91e2-e362aa110664.js",
    },
  ],
  meta: [
    {
      name: "google-site-verification",
      content: "tnrgFMykctSjic_CPeDNQbBgJVgJdMGbwD9gPWVjWfQ",
    },
    {
      property: "og:title",
      content: "Software Products, Web and Mobile App Development Company",
    },
    { property: "og:description", content: "WebReinvent Technologies Pvt Ltd is India's most process-oriented software, web, and mobile app development company. We build scalable CRM, ERP, HRM & SaaS solutions." },
    {
      property: "og:image",
      content: ogImageUrl,
    },
    {
      property: "og:image:secure_url",
      content: ogImageUrl,
    },
    {
      property: "og:image:width",
      content: "1200",
    },
    {
      property: "og:image:height",
      content: "630",
    },
    { property: "og:image:alt", content: "WebReinvent Technologies Pvt Ltd" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: ogUrl },
    {
      property: "og:site_name",
      content: "WebReinvent Technologies Pvt Ltd",
    },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: "WebReinvent: Leading Web, Mobile & AI Product Company" },
    { name: "twitter:description", content: "WebReinvent Technologies crafts process-driven web, mobile, and SaaS products, delivering enterprise AI solutions including intelligent automation, conversational AI, and custom machine learning" },
    { name: "twitter:image", content: ogImageUrl },
    { name: "twitter:site", content: "@webreinvent" },
  ],
  link: [
    {
      rel: "canonical",
      href: canonicalUrl,
    },
  ],
});
</script>
